import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@/context/userContext';
import { useSelector } from 'react-redux';
import { selectMyInfo } from '@/pages/auth/authSlice';

interface Props {
	shouldRefetch?: boolean;
	roleObj?: { [key: string]: [string, string, string?] };
}
export type useGetUserResultType = {
	userInfo: any;
	userInfoRefetch: any;
};
export function useGetUser<
	T extends useGetUserResultType = useGetUserResultType
>(props: Props = {}): T {
	const { shouldRefetch = false, roleObj = {} } = props;
	const { isLoading, isSuccess, userInfoRefetch } = useContext(UserContext);
	const userInfo = useSelector(selectMyInfo);

	// shouldRefetch 判断是否需要重新调用接口
	useEffect(() => {
		if (!isLoading && isSuccess && shouldRefetch) {
			userInfoRefetch();
		}
	}, [shouldRefetch]);

	return { userInfo, userInfoRefetch } as T;
}
